import { Injectable } from '@angular/core';
import { AbstractEntityValidator } from '@app/shared/validator/AbstractEntityValidator';
import { SpinnerService } from '@app/core/spinner/spinner.service';
import { AirportService } from '../service/aiport.service';
import { EntityCV } from '@app/shared/model/cv/EntityCV.model';

@Injectable({
  providedIn: 'root'
})
export class CoordinateAirportValidatorService extends AbstractEntityValidator {

  regExp = (/^[A-Z]{3}$/);

  constructor(
    public spinner: SpinnerService,
    public entityService: AirportService

  ) {
    super(spinner, entityService, EntityCV.all.AIRPORT, 'Coordinated');
  }

  validateFormat(value: string): boolean {
    return this.regExp.test(value);
  }

}
